import { createContext, useReducer } from "react";
import actions from "./Actions";
import StoreReducer from "./StoreReducer";
import axiosInstance from "../config/axios";
import { API } from "../config/api";
import fileDownload from "js-file-download";
const {
  GET_Api_DATA,
  GET_Api_DATA_LOAD,
  GET_Api_DATA_ERROR,
  VIDEO_DOWNLOADER,
  CHANGE_THEME,
} = actions;
export const initialState = {
  urlReturnData: null,
  loading: false,
  videoData: null,
  ApiData: (_: any) => {return Boolean},
  getVideo: (_: any) => {},
  ThemeSwitcher: () => {},
  theme: localStorage.getItem('theme')==="true"?true:false,
};
export const Apicontext = createContext(initialState);
export const ApiProvider = ({ children }: { children: any }) => {
  const [state, dispatch] = useReducer(StoreReducer, initialState);
  const ThemeSwitcher = () => {
    dispatch({
      type: CHANGE_THEME,
      payload: true,
    });
  };

  const ApiData = async (url: any) => {
    try {
      dispatch({
        type: GET_Api_DATA_LOAD,
        payload: true,
      });
      const response = await axiosInstance().post(API.transections.url, url);
      if (response.status === 200) {
        dispatch({
          type: GET_Api_DATA,
          payload: { ...response.data, ...url },
        });
        return true;
      } else {
        throw response;
      }
    } catch (error) {
      
      dispatch({
        type: GET_Api_DATA_ERROR,
        payload: false,
      });
      return false;
    }
  };
  const getVideo = async (data: any) => {
    dispatch({
      type: GET_Api_DATA_LOAD,
      payload: true,
    });
    axiosInstance()
      .post(API.transections.download, data, {
        maxBodyLength: Infinity,
        timeout: 20000 * 60,
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        fileDownload(res.data, "filename.mp4");
        dispatch({
          type: GET_Api_DATA_LOAD,
          payload: false,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_Api_DATA_LOAD,
          payload: false,
        });
      });
  };
  return (
    <Apicontext.Provider value={{ ...state, ApiData, getVideo, ThemeSwitcher }}>
      {children}
    </Apicontext.Provider>
  );
};
